<template>
  <div>
    <el-divider v-if="true">{{ title }}</el-divider>
    <template v-if="false">
      <template-item label="不能重复">
        <el-switch v-model="uniqueProxy" />
      </template-item>
      <template-item label="填写方向">
        <common-chooser :data-source="directions" v-model="directionProxy" />
      </template-item>
    </template>
    <biz-type-wrapper label="填写类型">
      <template #biz-type>
        <common-chooser
          :data-source="labelCatalogTypes"
          v-model="defaultBizProxy"
        />
        <biz-type-selector
          v-if="!defaultBiz"
          v-model="typeProxy"
          style="margin-left: 10px;"
        />
      </template>
      <template v-if="typeProxy" #action>
        <el-button type="text" @click="showMore = !showMore">
          <i v-if="showMore" class="el-icon-arrow-up" />
          <i v-else class="el-icon-arrow-down" />
          <span>高级设置</span>
        </el-button>
      </template>
    </biz-type-wrapper>

    <template v-if="showMore">
      <area-value-configure
        v-if="catalogProxy === catalogValue.area"
        :type.sync="typeProxy"
        :input-mode.sync="inputModeProxy"
        :forbidden-values.sync="forbiddenValuesProxy"
        :allowed-values.sync="allowedValuesProxy"
      />
      <date-value-configure
        v-else-if="catalogProxy === catalogValue.date"
        :type.sync="typeProxy"
        :input-mode.sync="inputModeProxy"
        :forbidden-values.sync="forbiddenValuesProxy"
        :allowed-values.sync="allowedValuesProxy"
      />
      <time-value-configure
        v-else-if="catalogProxy === catalogValue.time"
        :type.sync="typeProxy"
        :input-mode.sync="inputModeProxy"
        :forbidden-values.sync="forbiddenValuesProxy"
        :allowed-values.sync="allowedValuesProxy"
      />
      <other-value-configure
        v-else-if="catalogProxy === catalogValue.other"
        :type.sync="typeProxy"
        :input-mode.sync="inputModeProxy"
        :forbidden-values.sync="forbiddenValuesProxy"
        :allowed-values.sync="allowedValuesProxy"
        :custom-source.sync="customSourceProxy"
      />
      <template-item v-if="hasParent && existPossibleParent" label="关联的列">
        <common-single-selector v-model="parentProxy" :data-source="parentSource" />
      </template-item>
    </template>
  </div>
</template>

<script>
import { Switch, Button, Icon, Divider } from "element-ui";

import AreaValueConfigure from "@/components/excel/designer/configure/value/area/AreaConfigure";
import OtherValueConfigure from "@/components/excel/designer/configure/value/other/OtherConfigure";
import DateValueConfigure from "@/components/excel/designer/configure/value/date/DateConfigure";
import TimeValueConfigure from "@/components/excel/designer/configure/value/time/TimeConfigure";
import {
  AreaOption,
  DateOption,
  OtherCatalogOption,
  TimeOption,
} from "@/components/excel/schema/value/catalog";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";
import BizTypeWrapper from "@/components/excel/designer/configure/value/biz-type-wrapper";
import BizTypeSelector from "@/components/excel/designer/configure/value/biz-type-selector";
import CommonChooser from "@/components/selector/CommonChooser";
import { Direction } from "@/components/excel/schema/value/direction";
import {
  findCatalog,
  findModeChooser,
  findParent,
  maybeChild,
} from "@/components/excel/schema/value/type";
import { toExcelColumnLabel } from "@/utils/excel/ColumnConfig";
import CommonSingleSelector from "@/components/selector/CommonSingleSelector";
import { CellPosition } from "@/components/excel/schema/BaseSchema";

function numberToPosition(digit) {
  if (digit === undefined || digit === null) {
    return null;
  }
  const columnIndex = digit % 10000;
  const rowIndex = (digit - columnIndex) / 10000;
  return new CellPosition(rowIndex, columnIndex);
}
function positionToNumber(position) {
  if (position === undefined || position === null) {
    return null;
  }
  const { rowIndex, columnIndex } = position;
  return rowIndex * 10000 + columnIndex;
}
export default {
  name: "value-configure",
  components: {
    CommonSingleSelector,
    CommonChooser,
    BizTypeSelector,
    BizTypeWrapper,
    TemplateItem,
    TimeValueConfigure,
    DateValueConfigure,
    OtherValueConfigure,
    AreaValueConfigure,
    [Switch.name]: Switch,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Divider.name]: Divider,
  },
  props: {
    title: {
      type: String,
      default: "业务类型",
    },
    unique: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: Number,
      default: Direction.default,
    },
    type: {
      type: Number,
    },
    inputMode: {
      type: Number,
    },
    forbiddenValues: {
      type: Array,
    },
    allowedValues: {
      type: Array,
    },
    customSource: {
      type: Array,
      default: () => [],
    },
    defaultBiz: Boolean,
    titleBizType: Number,
    parent: {
      type: Object,
    },
    loadParent: Function,
  },
  computed: {
    uniqueProxy: {
      get() {
        return this.unique;
      },
      set(value) {
        this.emitChangeUnique(value);
      },
    },
    directionProxy: {
      get() {
        return this.direction;
      },
      set(value) {
        this.emitChangeDirection(value);
      },
    },
    typeProxy: {
      get() {
        const { defaultBiz, titleBizType, type } = this.$props;
        if (defaultBiz) {
          return titleBizType;
        }
        return type;
      },
      set(value) {
        this.emitChangeType(value);
      },
    },
    catalogProxy() {
      const catalogOption = findCatalog(this.typeProxy);
      return catalogOption ? catalogOption.value : null;
    },
    hasParent() {
      return maybeChild(this.typeProxy);
    },
    existPossibleParent() {
      return Array.isArray(this.parentSource) && this.parentSource.length > 0;
    },
    parentProxy: {
      get() {
        return positionToNumber(this.$props.parent);
      },
      set(value) {
        this.emitChangeParent(numberToPosition(value));
      },
    },
    inputModeProxy: {
      get() {
        return this.$props.inputMode;
      },
      set(value) {
        this.emitChangeInputMode(value);
      },
    },
    forbiddenValuesProxy: {
      get() {
        return this.$props.forbiddenValues;
      },
      set(value) {
        this.emitChangeForbiddenValues(value);
      },
    },
    allowedValuesProxy: {
      get() {
        return this.$props.allowedValues;
      },
      set(value) {
        this.emitChangeAllowedValues(value);
      },
    },
    customSourceProxy: {
      get() {
        return this.$props.customSource;
      },
      set(value) {
        this.emitChangeCustomSource(value);
      },
    },
    defaultBizProxy: {
      get() {
        return this.$props.defaultBiz ? 1 : 2;
      },
      set(value) {
        this.emitChangeDefaultBiz(value === 1);
      },
    },
    sameBizType() {
      const { defaultBiz, titleBizType, type } = this;
      return defaultBiz || titleBizType === type;
    },
  },
  data() {
    const area = AreaOption.value;
    const date = DateOption.value;
    const time = TimeOption.value;
    const other = OtherCatalogOption.value;
    const directions = Direction.options;
    const labelCatalogTypes = [
      { value: 1, text: "默认(与标题类型保持一致)" },
      { value: 2, text: "自定义" },
    ];
    return {
      directions,
      labelCatalogTypes,
      showMore: false,
      parentSource: [],
      catalog: null,
      catalogValue: {
        area,
        date,
        time,
        other,
      },
    };
  },
  watch: {
    type(type) {
      this.handleChangeType(type);
    },
    defaultBiz(value) {
      const { titleBizType, type } = this.$props;
      if (titleBizType === type) {
        return;
      }
      if (value) {
        this.handleChangeType(titleBizType);
      } else {
        this.handleChangeType(type);
      }
    },
    titleBizType(titleBizType){
      const { defaultBiz } = this.$props;
      if (defaultBiz){
        this.handleChangeType(titleBizType);
      }
    }
  },
  mounted() {
    const { direction, type, defaultBiz, titleBizType } = this.$props;
    if (!direction) {
      this.emitChangeDirection(Direction.default);
    }
    if (defaultBiz){
      this.handleChangeType(titleBizType);
    } else if (type) {
      this.handleChangeType(type);
    }
  },
  methods: {
    handleChangeType(type) {
      const chooser = findModeChooser(type);
      this.emitChangeInputMode(chooser.default);
      this.updateLocalCatalog(type);
      this.loadParentSource(type);
    },
    async loadParentSource(type) {
      // const parentType = await findParent(type);
      // if (parentType === undefined || parentType === null) {
      //   this.parentSource = [];
      //   return;
      // }
      const parentSource = await this.$props.loadParent(type);
      this.parentSource = (parentSource || []).map((it) => {
        const value = positionToNumber(it);
        const text = `${toExcelColumnLabel(it.columnIndex)}${it.rowIndex}`;
        return { value, text };
      });
    },
    updateLocalCatalog(type) {
      const catalogOption = findCatalog(type);
      console.log(catalogOption, type);
      this.catalog = catalogOption ? catalogOption.value : null;
    },
    emitChangeDirection(value) {
      this.$emit("update:direction", value);
      this.$emit("change-direction", value);
    },
    emitChangeUnique(value) {
      this.$emit("update:unique", value);
      this.$emit("change-unique", value);
    },
    emitChangeType(value) {
      this.$emit("update:type", value);
      this.$emit("change-type", value);
    },
    emitChangeInputMode(value) {
      this.$emit("update:input-mode", value);
      this.$emit("change-input-mode", value);
    },
    emitChangeAllowedValues(value) {
      this.$emit("update:allowed-values", value);
      this.$emit("change-allowed-values", value);
    },
    emitChangeForbiddenValues(value) {
      this.$emit("update:forbidden-values", value);
      this.$emit("change-forbidden-values", value);
    },
    emitChangeCustomSource(value) {
      this.$emit("update:custom-source", value);
      this.$emit("change-custom-source", value);
    },
    emitChangeParent(value) {
      this.$emit("update:parent", value);
      this.$emit("change-parent", value);
    },
    emitChangeDefaultBiz(value) {
      this.$emit("update:default-biz", value);
      this.$emit("change-default-biz", value);
    },
  },
};
</script>
